import { useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import { attachCertificate } from "../../api/payroll";
import { CertificateUpload } from "./CertificateUpload";

// Reminder row shown when a pending sick leave has no certificate attached yet.
export const MissingCertificate = ({ requestId, reload }) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  const save = async (url) => {
    await attachCertificate(requestId, url);
    toast.success(t("leaves.certificateAttached"));
    setOpen(false);
    reload?.();
  };

  return (
    <div className="mt-2" data-testid={`missing-certificate-${requestId}`}>
      {open ? (
        <CertificateUpload value="" onChange={save} />
      ) : (
        <button
          type="button"
          data-testid={`attach-certificate-${requestId}`}
          onClick={() => setOpen(true)}
          className="rounded-2xl px-3 py-1.5 text-xs font-bold text-amber-500 shadow-neu-sm transition-[box-shadow] duration-300 hover:shadow-neu-in"
        >
          {t("leaves.certificateMissing")}
        </button>
      )}
    </div>
  );
};
